import React, { ReactElement, ReactNode } from "react";
import {
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { Search2Icon } from "@chakra-ui/icons";

type Props = {
    placeholder?: string;
    value: string;
    onChange: (e:React.ChangeEvent<HTMLInputElement>) => void;
    onEnterPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  }

export const SearchBar = (props: Props) => {
  return (
    <>
      <InputGroup borderRadius={4} size="md" width='257px'>
        <InputRightElement
          pointerEvents="none"
          children={<Search2Icon color="brand.black" />}
        />
        <Input
          type="text"
          border='1px' 
          borderColor='brand.black'
          focusBorderColor='brand.black' 
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          _hover={{borderColor:'brand.black'}}
          onKeyDown={props.onEnterPress}
        />
      </InputGroup>
    </>
  );
};